'use client';

import styled, { TColorProp } from 'styled-components';

import { getThemeColor } from '~/common/utils/get-theme-color';

export type TSubheadingSize = 'medium' | 'small' | 'x-small' | '2x-small';

interface IContainerProps {
  $size: TSubheadingSize;
  $color: TColorProp;
}

const getLineHeight = {
  medium: 24,
  small: 20,
  'x-small': 16,
  '2x-small': 12,
} as Record<TSubheadingSize, number>;

const getFontSize = {
  medium: 16,
  small: 14,
  'x-small': 12,
  '2x-small': 11,
} as Record<TSubheadingSize, number>;

const getLetterSpacing = (size: TSubheadingSize): number => {
  const fontSize = getFontSize[size];
  const percentage = (
    {
      medium: 6,
      small: 6,
      'x-small': 4,
      '2x-small': 2,
    } as Record<TSubheadingSize, number>
  )[size];

  return (fontSize * percentage) / 100;
};

export const Container = styled.span<IContainerProps>`
  line-height: ${({ $size }) => getLineHeight[$size]}px;
  font-size: ${({ $size }) => getFontSize[$size]}px;
  letter-spacing: ${({ $size }) => getLetterSpacing($size)}px;
  text-transform: uppercase;
  font-weight: 500;
  color: ${({ theme, $color }) => getThemeColor(theme, $color)};
`;
